function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import PaginationVue from '@/components/PaginationVue';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { envConfig } from '@/js/constants';
import tasks from '@/js/tasks';
export default {
  name: 'ProductizeTransformedAttributeDetail',
  components: {
    PaginationVue: PaginationVue
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      expandedRows: [],
      // control de filas expandidas
      tab: null,
      useCaseLogs: [],
      tableInternalItems: [],
      internal_headers: [{
        text: 'Atributo',
        value: 'attribute_name'
      }],
      tableOutputItems: [],
      output_headers: [{
        text: 'Atributo',
        value: 'attribute_name'
      }],
      logItems: [],
      log_headers: [{
        text: 'Descripción',
        value: 'description'
      }, {
        text: 'Tipo de evento',
        value: 'event_type'
      }, {
        text: 'Ambiente',
        value: 'environment'
      }, {
        text: 'Usuario',
        value: 'user'
      }, {
        text: 'Respuesta',
        value: 'response'
      }, {
        text: 'Creación',
        value: 'creation_date'
      }],
      export_events_headers: [{
        text: 'Fecha de inicio',
        value: 'start_date'
      }, {
        text: 'Fecha de fin',
        value: 'end_date'
      }, {
        text: 'Usuario',
        value: 'creation_user'
      }, {
        text: 'Estado de ejecución',
        value: 'status'
      }, {
        text: 'Creación',
        value: 'creation_date'
      }],
      info: {},
      loading: false,
      keyTable: 0,
      keyTable2: 0,
      keyTable3: 0,
      keyTable4: 0,
      pagination: {
        attributes: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        output: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        logs: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0,
          sort_by: ['creation_date'],
          sort_desc: [true]
        },
        exportEvents: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0,
          sort_by: ['creation_date'],
          sort_desc: [true]
        }
      },
      fileBase64: null,
      file: null,
      rules: {
        file: [function (v) {
          return !!v || _this.translate('customer_insights.rules.file');
        }, function (v) {
          return !v || v.size < 2000000 || _this.translate('customer_insights.rules.file_size');
        }]
      },
      exportEvents: []
    };
  },
  created: function created() {
    console.log("item props:", this.item);
    this.getLogStatus();
    this.getAttributeAutomateHistory();
  },
  methods: {
    copyAwsTableName: function copyAwsTableName() {
      if (!this.awsTableName) return;
      navigator.clipboard.writeText(this.awsTableName).then(function () {
        return tasks.toast.success('Copiado');
      }).catch(function () {
        return tasks.toast.error('No se pudo copiar');
      });
    },
    getLogStatus: function getLogStatus() {
      var _this2 = this;
      UseCasesService.getLogStatus(this.item.automate_id).then(function (response) {
        _this2.info = response.data.records;
        var raw = _this2.info.input_attributes || [];
        _this2.tableInternalItems = raw.map(function (a, idx) {
          var obj = typeof a === 'string' ? {
            attribute_name: a
          } : a;
          return _objectSpread(_objectSpread({}, obj), {}, {
            id: "".concat(obj.attribute_category || 'NA', "::").concat(obj.attribute_name || idx) // clave única
          });
        });
        _this2.pagination.attributes.total = _this2.tableInternalItems.length;
        _this2.logItems = response.data.records.logs;
        _this2.pagination.logs.total = _this2.logItems.length;
        if (response.data.records.output_attributes !== '{}' && response.data.records.output_attributes !== null) {
          _this2.tableOutputItems = response.data.records.output_attributes.map(function (x) {
            return {
              attribute_name: x
            };
          });
          _this2.pagination.output.total = _this2.tableOutputItems.length;
        }
        _this2.keyTable++;
        _this2.keyTable2++;
        _this2.keyTable3++;
      });
    },
    getAttributeAutomateHistory: function getAttributeAutomateHistory() {
      var _this3 = this;
      UseCasesService.getAttributeAutomateHist(this.item.automate_id).then(function (response) {
        console.log(response);
        _this3.exportEvents = response.data.records;
      });
    },
    getDateAndHours: function getDateAndHours(created) {
      var date = new Date(created);
      date.setHours(date.getHours() - 5);
      return {
        date: this.$moment(date).format('DD-MM-YYYY'),
        hour: this.$moment(date).format('HH:mm:ss')
      };
    },
    onFileSelected: function onFileSelected() {
      var _this4 = this;
      if (!this.file) {
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        _this4.fileBase64 = event.target.result.split(',')[1]; // Get base64 string, remove "data:...;base64,"
        _this4.onUpdateFileAutomation();
      };
      reader.readAsDataURL(this.file);
    },
    onUpdateFileAutomation: function onUpdateFileAutomation() {
      var _this5 = this;
      this.tableInternalItems.forEach(function (x) {
        x.status_aprov = true;
      });
      var data = {
        automation_id: this.item.automate_id,
        scr_b64: this.fileBase64
      };
      UseCasesService.updateFileAutomation(data).then(function (response) {
        if (response.status_process == 1) {
          tasks.toast.success("Se ha generado una solicitud de revisión, espere la confirmación.");
          _this5.$emit("getHistory");
          _this5.$emit("onClose");
        } else {
          tasks.toast.success("Se ha iniciado el proceso, espere unos minutos a que culmine.");
          _this5.$emit("getHistory");
          _this5.$emit("onClose");
        }
      });
    },
    onDownloadFile: function onDownloadFile() {
      var _this6 = this;
      UseCasesService.getProductizeDetail({}, this.item.project_id, this.item.segment_id, this.item.type_export_id).then(function (response) {
        var records = response.data.records;
        var base64EncodedSql = records.descargar_archivo;
        var decodedSql = atob(base64EncodedSql);
        var blob = new Blob([decodedSql], {
          type: 'text/plain'
        });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        if (_this6.item.type_export_id === 4) {
          link.download = 'archivo.py';
        } else {
          link.download = 'archivo.sql';
        }
        link.click();
        URL.revokeObjectURL(link.href);
      });
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    awsTableName: function awsTableName() {
      console.log("info:", this.info);
      var scheme = this.info && this.info.destination_scheme ? this.info.destination_scheme : '';
      var useCase = this.info && this.info.use_case ? this.info.use_case : '';
      var segment = this.info && this.info.segment ? this.info.segment : '';
      console.log("scheme, useCase, segment:", scheme, useCase, segment);
      if (!scheme || !useCase || !segment) return '';
      return this.info.type_register == 'binning' ? '"' + scheme.replace(/_rlink/gi, '') + '"."dlv_' + useCase + '_' + segment + '"' : '"' + scheme.replace(/_rlink/gi, '') + '"."' + segment + '"';
    },
    awsTableNameProd: function awsTableNameProd() {
      var item = this.item || {};
      var segmento = item.segmento ? item.segmento.replace(/-/g, '_') : '';
      return "\"e_perm_aws\".\"".concat(segmento, "\" ");
    }
  })
};